import * as React from "react";
import { useTranslation } from "react-i18next";
import { Field } from "formik";
import * as Immutable from "immutable";
import ColumnSelect from "./ColumnSelect";
import SelectedColumnsList from "./SelectedColumnsList";
const ColumnsConfiguration = ({
  columnTitle,
  columns,
  createSelectPlaceholder = void 0,
  displaySortableListOverlayInPortal = false,
  name
}) => {
  const { t } = useTranslation("widgets");
  return /* @__PURE__ */ React.createElement(Field, { name }, ({ field: { value, onChange } }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    SelectedColumnsList,
    {
      selectedColumns: value.toArray(),
      columnTitle,
      displayOverlayInPortal: displaySortableListOverlayInPortal,
      onChange: (newColumns) => onChange({ target: { value: Immutable.OrderedSet(newColumns), name } })
    }
  ), /* @__PURE__ */ React.createElement(
    ColumnSelect,
    {
      id: "column-create-select",
      columnTitle,
      columns,
      onChange: (newColumn) => onChange({ target: { value: Immutable.OrderedSet([...value.toArray(), newColumn]), name } }),
      clearable: false,
      persistSelection: false,
      name: "column-create-select",
      value: void 0,
      excludedColumns: value,
      placeholder: createSelectPlaceholder != null ? createSelectPlaceholder : t("overview_configuration.add_column"),
      ariaLabel: createSelectPlaceholder != null ? createSelectPlaceholder : t("overview_configuration.add_column")
    }
  )));
};
export default ColumnsConfiguration;
